export function NumberInput({ value, onChange }: { value: number | string; onChange: (v: number) => void }) {
  return (
    <input
      type="number"
      value={value ?? ''}
      onChange={e => onChange(Number(e.target.value))}
      className="border rounded px-2 py-1 text-sm flex-1"
    />
  )
}
